// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Asap&family=Exo+2:wght@200&family=Josefin+Sans:wght@200&family=Macondo&family=Oleo+Script&family=Pacifico&family=Playfair+Display:ital@1&family=Tapestry&family=Titillium+Web:wght@200&family=Yanone+Kaffeesatz:wght@300&family=Zen+Loop:ital@1&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Joan&family=Lora:ital,wght@1,500&family=Montserrat:wght@500&family=Nunito+Sans:ital,wght@1,300&family=Playfair+Display:ital,wght@1,600&family=Roboto+Slab&family=Source+Sans+Pro&family=Tai+Heritage+Pro&family=Ubuntu&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anton&family=Great+Vibes&family=League+Spartan:wght@800&family=Playfair+Display:ital,wght@0,900;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Update 1 */ /* Update 2 */ /* Update 3 */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  /* font-family: 'Asap', sans-serif; */
  /* color: #000; */
  /* link 1 */
  /* font-family: 'Exo 2', sans-serif; */
  /* font-family: 'Josefin Sans', sans-serif; */
  /* font-family: 'Macondo', cursive; */
  /* font-family: 'Oleo Script', cursive; */
  /* font-family: 'Pacifico', cursive; */
  /* font-family: 'Playfair Display', serif; */
  /* font-family: 'Tapestry', cursive; */
  /* font-family: 'Titillium Web', sans-serif; */
  /* font-family: 'Yanone Kaffeesatz', sans-serif; */
  /* font-family: 'Zen Loop', cursive; */
  /* link 2 */
  /* font-family: 'Bebas Neue'; */
  /* font-family: 'Joan'; */
  /* font-family: 'Lora'; */
  /* font-family: 'Montserrat'; */
  /* font-family: 'Nunito Sans'; */
  /* font-family: 'Playfair Display'; */
  /* font-family: 'Roboto Slab'; */
  font-family: "Source Sans Pro";
  /* font-family: 'Tai Heritage Pro'; */
  /* font-family: "Ubuntu"; */
}

body {
  background-color: var(--main-color);
}

.colorConceptActive {
  background-color: var(--main-color);
}

.errorFocusActive {
  border: 2px solid red;
}

.activeFlex {
  display: flex;
}

.active {
  display: block;
}

input:focus {
  outline: none !important;
  border: 2px solid #000;
}

input {
  margin: 0 !important;
  border: 1px solid #000;
  border-radius: 10px;
  padding: 5px;
}

textarea {
  border-radius: 10px;
  border: solid #000 1px;
}

textarea:focus {
  outline: none !important;
  border: 2px solid #000 !important;
}

/* Button style */
.typebox {
  padding: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border-radius: 14px;
  border: 3px solid transparent;
  background-color: #fff;
}

.typebox.active {
  background: linear-gradient(white, white) padding-box, linear-gradient(to right, darkblue, darkorchid) border-box;
}

/* RESPONSIVE FOR DEVICES THAT ARE NOT SUPPORTED */
@media only screen and (max-width: 340px) {
  body {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./controllers/client/css/universal.css"],"names":[],"mappings":"AAAQ,aAAA,EACA,aAAA,EACA,aAAA;AAER;EACE,UAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,iBAAA;EACA,WAAA;EACA,sCAAA;EACA,6CAAA;EACA,qCAAA;EACA,yCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,8CAAA;EACA,kDAAA;EACA,sCAAA;EACA,WAAA;EACA,+BAAA;EACA,yBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,qCAAA;EACA,gCAAA;EACA,8BAAA;EACA,qCAAA;EACA,2BAAA;AAAF;;AAEA;EACE,mCAAA;AACF;;AACA;EACE,mCAAA;AAEF;;AAAA;EACE,qBAAA;AAGF;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,wBAAA;EACA,sBAAA;AAMF;;AAJA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAOF;;AALA;EACE,mBAAA;EACA,sBAAA;AAQF;;AANA;EACE,wBAAA;EACA,iCAAA;AASF;;AAPA,iBAAA;AACA;EACE,aAAA;EACA,yFAAA;EAEA,mBAAA;EACA,6BAAA;EACA,sBAAA;AASF;;AAPA;EACE,iHAAA;AAUF;;AANA,kDAAA;AACA;EACE;IACE,aAAA;EASF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Asap&family=Exo+2:wght@200&family=Josefin+Sans:wght@200&family=Macondo&family=Oleo+Script&family=Pacifico&family=Playfair+Display:ital@1&family=Tapestry&family=Titillium+Web:wght@200&family=Yanone+Kaffeesatz:wght@300&family=Zen+Loop:ital@1&display=swap\"); /* Update 1 */\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Joan&family=Lora:ital,wght@1,500&family=Montserrat:wght@500&family=Nunito+Sans:ital,wght@1,300&family=Playfair+Display:ital,wght@1,600&family=Roboto+Slab&family=Source+Sans+Pro&family=Tai+Heritage+Pro&family=Ubuntu&display=swap\"); /* Update 2 */\n@import url(\"https://fonts.googleapis.com/css2?family=Anton&family=Great+Vibes&family=League+Spartan:wght@800&family=Playfair+Display:ital,wght@0,900;1,900&display=swap\"); /* Update 3 */\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  /* font-family: 'Asap', sans-serif; */\n  /* color: #000; */\n  /* link 1 */\n  /* font-family: 'Exo 2', sans-serif; */\n  /* font-family: 'Josefin Sans', sans-serif; */\n  /* font-family: 'Macondo', cursive; */\n  /* font-family: 'Oleo Script', cursive; */\n  /* font-family: 'Pacifico', cursive; */\n  /* font-family: 'Playfair Display', serif; */\n  /* font-family: 'Tapestry', cursive; */\n  /* font-family: 'Titillium Web', sans-serif; */\n  /* font-family: 'Yanone Kaffeesatz', sans-serif; */\n  /* font-family: 'Zen Loop', cursive; */\n  /* link 2 */\n  /* font-family: 'Bebas Neue'; */\n  /* font-family: 'Joan'; */\n  /* font-family: 'Lora'; */\n  /* font-family: 'Montserrat'; */\n  /* font-family: 'Nunito Sans'; */\n  /* font-family: 'Playfair Display'; */\n  /* font-family: 'Roboto Slab'; */\n  font-family: 'Source Sans Pro';\n  /* font-family: 'Tai Heritage Pro'; */\n  /* font-family: \"Ubuntu\"; */\n}\nbody {\n  background-color: var(--main-color);\n}\n.colorConceptActive {\n  background-color: var(--main-color);\n}\n.errorFocusActive {\n  border: 2px solid red;\n}\n.activeFlex {\n  display: flex;\n}\n.active {\n  display: block;\n}\ninput:focus {\n  outline: none !important;\n  border: 2px solid #000;\n}\ninput {\n  margin: 0 !important;\n  border: 1px solid #000;\n  border-radius: 10px;\n  padding: 5px;\n}\ntextarea {\n  border-radius: 10px;\n  border: solid #000 1px;\n}\ntextarea:focus {\n  outline: none !important;\n  border: 2px solid #000 !important;\n}\n/* Button style */\n.typebox {\n  padding: 10px;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n  border-radius: 14px;\n  border: 3px solid transparent;\n  background-color: #fff;\n}\n.typebox.active {\n  background: linear-gradient(white, white) padding-box,\n    linear-gradient(to right, darkblue, darkorchid) border-box;\n}\n\n/* RESPONSIVE FOR DEVICES THAT ARE NOT SUPPORTED */\n@media only screen and (max-width: 340px) {\n  body {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
